import { trackECommerce } from './eCommerce';

export const createECommerceTrackingClient = () => {
  return {
    trackEvent: trackECommerce,
  };
};
